module.exports = __webpack_public_path__ + "img/i_fxsy_dcx.995ea42f.png";